import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../api/request";
import StepRoutes from "../../Routes/steps_routes";
import CustomInput from "../../CustomComponent/custom_input";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import Footer from "../../Components/Footer/footer";
import LoadingPage from "../../Components/layouts/loading";
import { CreateNewSI } from "../../SchemaInfo/info";
import { createSISchema } from "../../Schemas/Site Inspection/SI_create_schema";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcKindle } from "react-icons/fc";

const EditSIUpdate = () => {
  const [data, setData] = useState(CreateNewSI);
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handelSubmit = (values, actions) => {
    setLoading(true);
    performRequest("PATCH", `/si-updates/update-si-update/${id}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "SI updated successfully!");
          navigate(`/si-updates/view/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/si-updates/getsiUpdatesById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1"><FcKindle></FcKindle>Edit SI Updates</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit SI Updates</h2>
            </div>
            <Formik
              initialValues={data}
              validationSchema={createSISchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="name" type="text" />
                        {props.touched.name && props.errors.name && (
                          <p className="text-danger">{props.errors.name}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Email</label>
                      <div className="w-100 col">
                        <CustomInput name="email" type="text" />
                        {props.touched.email && props.errors.email && (
                          <p className="text-danger">{props.errors.email}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Contact number
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="contactNumber" type="text" />
                        {props.touched.contactNumber &&
                          props.errors.contactNumber && (
                            <p className="text-danger">
                              {props.errors.contactNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Watsappp number
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="watsapppNumber" type="text" />
                        {props.touched.watsapppNumber &&
                          props.errors.watsapppNumber && (
                            <p className="text-danger">
                              {props.errors.watsapppNumber}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Enroll date
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="enrollDate" type="date" />
                        {props.touched.enrollDate &&
                          props.errors.enrollDate && (
                            <p className="text-danger">
                              {props.errors.enrollDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Amount paid
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="amountPaid" type="text" />
                        {props.touched.amountPaid &&
                          props.errors.amountPaid && (
                            <p className="text-danger">
                              {props.errors.amountPaid}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Payment Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="paymentDate" type="date" />
                        {props.touched.paymentDate &&
                          props.errors.paymentDate && (
                            <p className="text-danger">
                              {props.errors.paymentDate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Payment mode
                      </label>
                      <div className="w-100 col">
                        <CustomSelect name="paymentMode" type="text">
                          <option value="">Select</option>
                          <option value="cash">Cash</option>
                          <option value="cheque">Cheque</option>
                          <option value="upi">UPI</option>
                          <option value="imps">IMPS</option>
                          <option value="rtgs">RTGS</option>
                          <option value="neft">NEFT</option>
                        </CustomSelect>
                        {props.touched.paymentMode &&
                          props.errors.paymentMode && (
                            <p className="text-danger">
                              {props.errors.paymentMode}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Address
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="Address" type="text" />
                        {props.touched.Address && props.errors.Address && (
                          <p className="text-danger">{props.errors.Address}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Save SI Updates" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditSIUpdate;
